import { useFirstOrderIncentiveStore } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";
import { bpsToPercentString } from "@faire/retailer-visitor-shared/lib/bpsUtils";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { formatMoney, moneyOrZero, RoundingStrategy } from "@faire/web--source/common/money";
export var useFirstOrderIncentiveFormattedData = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useFirstOrderIncentiveStore = useFirstOrderIncentiveStore(), incentiveData = _useFirstOrderIncentiveStore.formattedIncentiveData;
    var incentiveAmount = incentiveData.incentiveAmount, incentiveMinimum = incentiveData.incentiveMinimum, incentiveBps = incentiveData.incentiveBps, incentiveMaxOfferAmount = incentiveData.incentiveMaxOfferAmount;
    var formattedIncentiveAmount = formatMoney({
        money: moneyOrZero(incentiveAmount),
        roundingStrategy: RoundingStrategy.DROP_CENTS
    });
    var formattedIncentivePercent = bpsToPercentString(incentiveBps !== null && incentiveBps !== void 0 ? incentiveBps : 0, strictLocalize);
    var formattedIncentiveMinimum = formatMoney({
        money: moneyOrZero(incentiveMinimum),
        roundingStrategy: RoundingStrategy.DROP_CENTS
    });
    var formattedIncentiveMaxOfferAmount = formatMoney({
        money: moneyOrZero(incentiveMaxOfferAmount),
        roundingStrategy: RoundingStrategy.DROP_CENTS
    });
    return {
        formattedIncentivePercent: formattedIncentivePercent,
        formattedIncentiveAmount: formattedIncentiveAmount,
        formattedIncentiveMinimum: formattedIncentiveMinimum,
        formattedIncentiveMaxOfferAmount: formattedIncentiveMaxOfferAmount
    };
};
